import gql from 'graphql-tag';

export const VrboPriceSummaryFragments = {
    VrboPriceSummary: gql`
        fragment VrboTravelerPriceSummary on PriceSummary {
            perNight {
                amount
                formattedAmount
                roundedFormattedAmount
                pricePeriodDescription
            }
            total {
                amount
                formattedAmount
                roundedFormattedAmount
                pricePeriodDescription
            }
            label
            mainPrice
        }
    `
};

export default VrboPriceSummaryFragments;
